import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12.3a9 9 0 1 0 -8.683 8.694","key":"svg-0"}],["path",{"d":"M12 7v5l2 2","key":"svg-1"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}]]

const IconClockRecord = createReactComponent('outline', 'clock-record', 'ClockRecord', __iconNode);

export default IconClockRecord;